module.exports = __webpack_public_path__ + "69b3ebe5e7653d5051923c04a6d9f154.png";